module.exports = __webpack_public_path__ + "img/sankaku_35_red.62f6490d.png";